
export default {
  SET_VESSEL(state, payload) {
    state.vessel = payload.vessel;
  },
  SET_FETCH_PICTURES_STATE(state, payload) {
    state.isFetchingPictures = payload;
  },

  SET_PICTURES(state, payload) {
    state.pictures = payload
  },
  SET_LIGHT_BOX_PICTURES_PICTURES(state, payload) {
    state.lightBoxPictures = payload
  },
}
